/*
* Google Places API plugin.
* Loads google API if there is no "google" object already present (window.google).
*
* NOTES:
*   - IF the client application is using another plugin that also loads the google API, THEN install this plugin first!
*   - Requires an API key to work properly.
*     - IF used directly and "key" is not informed on installation options, THEN the plugin will throw an error;
*     - IF used through the VAA plugin and "googleApiKey" is not informed on installation options, THEN
*       the plugin will not be installed.
*/

const loadApi = googleApiKey => new Promise((resolve, reject) => {
  try {
    const callbackName = 'vueGoogleMapsInit';
    const baseApiUrl = 'https://maps.googleapis.com';
    const apiOptions = {
      key: googleApiKey,
      libraries: 'places',
      callback: callbackName,
    };
    const optionsURI = Object.keys(apiOptions)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(apiOptions[key])}`)
      .join('&');

    const googleAPIScript = document.createElement('script');
    googleAPIScript.setAttribute('src', `${baseApiUrl}/maps/api/js?${optionsURI}`);
    googleAPIScript.setAttribute('async', '');
    googleAPIScript.setAttribute('defer', '');
    document.body.appendChild(googleAPIScript);
    window[callbackName] = resolve;
  } catch (err) {
    reject(err);
  }
});

const GooglePlacesAPI = {
  install(Vue, { key } = {}) {
    if (!Object.prototype.hasOwnProperty.call(window, 'google')) {
      const googleMonitor = Vue.observable({
        google: false,
      });

      Object.defineProperty(window, 'google', {
        get() {
          return googleMonitor.google;
        },
        set(google) {
          googleMonitor.google = google;
        },
      });

      loadApi(key)
        .then(() => {})
        .catch(() => {
          throw new Error('Could not initialize Google Places API');
        });
    }
  },
};

export default GooglePlacesAPI;
